import { Alert, Button, Col, Descriptions, List, Tabs } from "antd";
import { IPolicyEquipmentModel, IPolicyEquipmentModelFetchingInfo } from "../../baseInfo/policyEquipmentModel/interfaces";
import { BaseEntityManager, } from "../../components/entityManager";
import { enmControlType, enmEntityManagerState, enmPropertyType, IEntityManagerProps, IEntityManagerStates, IInitialData, IMetadata } from "../../components/entityManager/interfaces";
import { ComparisonFilter, IFilter } from "../../components/infrastructure/filtering";
import { enmOrderingType, ICallOptions, IOrdering, IPaging } from "../../components/infrastructure/models";
import { PdfViewer } from "../../components/pdfViewer";
import { DamageCaseCreate } from "../damageCasePolicyholder/damageCaseCreate";
import { InquiryPolicy } from "./inquiry";
import { InfoCircleFilled } from "@ant-design/icons";
import { Core } from "../../components/infrastructure/core";

const { TabPane } = Tabs;

export interface IPolicyListProps extends IEntityManagerProps<IPolicyEquipmentModel> {
    params?: () => { loadPolicyDamageCases: boolean; };
}

interface IPolicyListStates extends IEntityManagerStates<IPolicyEquipmentModel> {
    policyCertFrameDisplayed?: boolean;
}

export class PolicyList extends BaseEntityManager<IPolicyEquipmentModel, IPolicyListProps, IPolicyListStates, IPolicyEquipmentModelFetchingInfo, IInitialData> {
    static initMetadata = (): IMetadata => {
        return {
            name: "Policy",
            title: "بیمه های من",
            Properties: [
                {
                    title: "سریال تجهیز",
                    dataIndex: "EquipmentSerialNo",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    disabled: false,
                    filterable: true,
                    width: 150
                },
                {
                    title: "سریال بیمه نامه",
                    dataIndex: "Policy.SerialNo",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    disabled: false,
                    filterable: true,
                    width: 150
                },
                {
                    title: "شروع بیمه نامه",
                    dataIndex: "Policy.StartDateTime",
                    propertyType: enmPropertyType.datetime,
                    controlType: enmControlType.datetime,
                    disabled: false,
                    width: 150
                },
                {
                    title: "پایان بیمه نامه",
                    dataIndex: "Policy.EndDateTime",
                    propertyType: enmPropertyType.datetime,
                    controlType: enmControlType.datetime,
                    disabled: true,
                    width: 150
                },
                {
                    title: "تجهیز",
                    dataIndex: "Equipment.Name",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    disabled: true,
                    filterable: true,
                    width: 150
                },
                {
                    title: "برند",
                    dataIndex: "BrandTitle",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    disabled: true,
                    width: 150
                },
                {
                    title: "مدل تجهیز",
                    dataIndex: "EquipmentModelTitle",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    disabled: true,
                    filterable: true,
                    width: 150
                },
                {
                    title: "بیمه گزار/مشتری",
                    dataIndex: "Policy.Policyholder.FullName",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: false,
                    sortable: false,
                    disabled: true,
                    width: 150
                },
                {
                    title: "کد ملی بیمه گزار/مشتری",
                    dataIndex: "Policy.Policyholder.NationalCode",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    disabled: true,
                    width: 150
                },
                {
                    title: "سرمایه بیمه نامه",
                    dataIndex: "InsuredValue",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.priceinput,
                    filterable: false,
                    disabled: false,
                    width: 150
                },
            ]
        };
    }
    tabsElement?: HTMLDivElement | null;
   
    onInitializing() {
        this.baseUrl = "portal";
        this.getUrl = "portal/PolicyList";
        this.getInitialDataUrl = "portal/GetPolicyListInitialData";

        this.searchable = true;
        this.searchArea = {
            columnsPerRow: 2
        };

        this.originalOrderings = () => [{ OrderBy: enmOrderingType.Descending, Property: 'Policy.StartDateTime' }];

        this.onDataFetching = (fetchingInfo, onViewMode) => {
            fetchingInfo.LoadPolicyDamageCases = onViewMode || (this.props.params && this.props.params()?.loadPolicyDamageCases);
            fetchingInfo.LoadPolicyNavigations = onViewMode;
            fetchingInfo.LoadPolicyAttachments = onViewMode;
        };

        this.extraHeaderButtons = () => {
            return (
                [<Button key="inquiryPolicies" style={{ lineHeight: '0.5em', verticalAlign: 'middle', width: '100px' }} type="primary" onClick={this.inquiryPolicies} loading={this.state.loading}>بروزرسانی</Button>]
            );
        };

        this.renderingToolbar = () => {
            if (!this.selectedEntity)
                return <></>;

            const policy = this.selectedEntity?.Policy;

            let endDateTime = new Date(policy.EndDateTime);
            let minValidDate = new Date();
            minValidDate.setMonth(minValidDate.getMonth() - 1);
            if (minValidDate.getTime() > endDateTime.getTime()) { // بیش از یک ماه از انقضای بیمه نامه گذشته است
                return <></>;
            }
            return (
                <Col key="SendToEvaluation" style={{ marginLeft: 10 }}>
                    <Button key="createDamageCaseButton" type="primary" onClick={() => this.fetchItem()}>ثبت خسارت جدید </Button>
                </Col>
            );
        };

        this.extraHeaderNodes = () => {
            return (
                this.state.state === enmEntityManagerState.List && <Alert
                    style={{ marginTop: 10, marginBottom: 20, textAlign: 'justify' }}
                    message={
                        <>
                            <span>بیمه گزار/مشتری گرامی، چنانچه بیمه نامه مد نظر در لیست زیر موجود نیست، از طریق</span>
                            <Button key="inquiryPolicyButton" type="link" onClick={() => this.inquiryPolicy()}><b>استعلام بیمه نامه</b></Button>
                            <span>نسبت به ثبت دستگاه خود اقدام نمایید.</span>
                            <br />
                            <span>همچنین جهت مشاهده جزئیات و ثبت خسارت، می توانید روی ردیف مورد نظر کلیک نمایید</span>
                        </>
                    }
                    type="info"
                    icon={<InfoCircleFilled className="blink" />}
                    showIcon
                />
            );
        };
        this.extraViewNode = () => {

            const { currentEntity } = this.state;
            if (!currentEntity || !currentEntity.Policy)
                return;

            const policyEquipmentModel = currentEntity;
            const equipmentName = policyEquipmentModel.Equipment.Name;
            const equipmentModelName = policyEquipmentModel.EquipmentModelTitle;
            const brandName = policyEquipmentModel.BrandTitle;

            const policyCert = currentEntity.Policy.PolicyAttachments[0];

            return (
                <div style={{ margin: 0, marginTop: 10 }} ref={node => this.tabsElement = node}>
                    <div className="box" style={{ border: "1px solid #91b5b7" }}>
                        <Tabs defaultActiveKey="1" onChange={key => {
                            if (this.tabsElement) {
                                this.setState({ policyCertFrameDisplayed: key === "4" });
                            }
                        }}>
                            <TabPane
                                tab={
                                    <span style={{ marginRight: 10 }}>
                                        جزئیات
                                    </span>
                                }
                                key="1"
                                style={{ margin: 10 }}
                            >
                                <Descriptions key={"PolicyDetails"} column={{ xxl: 4, xl: 4, lg: 2, md: 2, sm: 1, xs: 1 }}>
                                    {/*{*/}
                                    {/*    !!policyCert &&*/}
                                    {/*    <Descriptions.Item key="PolicyCert" label={<DownloadOutlined />}>*/}
                                    {/*        <a href={policyCert.Path} download={policyCert.Title} title="دانلود">*/}
                                    {/*            گواهی بیمه نامه*/}
                                    {/*        </a>*/}
                                    {/*    </Descriptions.Item>*/}
                                    {/*}*/}
                                    <Descriptions.Item label="سریال یا IMEI دستگاه">{policyEquipmentModel.EquipmentSerialNo}</Descriptions.Item>
                                    <Descriptions.Item label="دستگاه">{equipmentName + " - " + brandName}</Descriptions.Item>
                                    {equipmentModelName && <Descriptions.Item label="مدل">{equipmentModelName}</Descriptions.Item>}
                                    <Descriptions.Item label="سرمایه بیمه نامه">{`${policyEquipmentModel.InsuredValue ?? 0} ریال`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</Descriptions.Item>
                                </Descriptions>
                            </TabPane>
                            <TabPane
                                tab={
                                    <span>
                                        فرانشیز ها
                                    </span>
                                }
                                key="2"
                                style={{ margin: 10 }}
                            >
                                <List
                                    itemLayout="horizontal"
                                    dataSource={currentEntity.Policy.PolicyFranchises.map(f => { return { title: f.FranchiseTitle, percent: f.FranchisePercent, minimumValue: f.MinimumValue } })}
                                    renderItem={item => (
                                        <List.Item>
                                            <List.Item.Meta
                                                title={
                                                    <Descriptions key={"PolicyFranchises"}>
                                                        <Descriptions.Item className="col-sm-6" label="عنوان">{item.title}</Descriptions.Item>
                                                        <Descriptions.Item className="col-sm-2" label="درصد">{item.percent}</Descriptions.Item>
                                                        <Descriptions.Item className="col-sm-4" label="حداقل مبلغ فرانشیز">{`${item.minimumValue ?? 0} ریال`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</Descriptions.Item>
                                                    </Descriptions>
                                                }
                                            />
                                        </List.Item>
                                    )}
                                />
                            </TabPane>
                            <TabPane
                                tab={
                                    <span style={{ marginRight: 4 }}>
                                        پوشش ها
                                    </span>
                                }
                                key="3"
                                style={{ margin: 10 }}
                            >
                                <List
                                    itemLayout="horizontal"
                                    dataSource={currentEntity.Policy.PolicyCoverages.map(c => { return { title: c.CoverageTitle } })}
                                    renderItem={item => (
                                        <List.Item>
                                            <List.Item.Meta
                                                title={
                                                    <Descriptions key={"PolicyCoverages"} column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}>
                                                        <Descriptions.Item label="عنوان">{item.title}</Descriptions.Item>
                                                    </Descriptions>
                                                }
                                                style={{ height: 25 }}
                                            />
                                        </List.Item>
                                    )}
                                />
                            </TabPane>
                            {
                                !!policyCert &&
                                <TabPane
                                    tab={
                                        <span style={{ marginRight: 4 }}>
                                            گواهی بیمه نامه
                                        </span>
                                    }
                                    key="4"
                                    style={{ margin: 10, minHeight: 600 }}
                                >
                                    <div style={{ width: 'calc(100% - 20px)' }}>
                                        {this.state.policyCertFrameDisplayed && <PdfViewer url={policyCert?.Path} onLoad={() => this.tabsElement?.scrollIntoView()} />}
                                    </div>
                                </TabPane>
                            }
                        </Tabs>
                    </div>
                </div>
            );
        };
    }
    inquiryPolicy = () => {
        this.addLookupForm("InquiryPolicy",
            <InquiryPolicy key="InquiryPolicy"
                onClose={data => {
                    this.onLookupClosed();
                    if (data)
                        this.view(data.RowGuid);
                }}
            />
        );
    }
    async fetchItem() {
        if (!this.selectedEntity)
            return;

        const { RowGuid } = this.selectedEntity;

        let fetchingInfo = {
            Orderings: [] as IOrdering[],
            Paging: { PageNo: 1, PageSize: 1 } as IPaging,
            Filter: ComparisonFilter.Equal<IPolicyEquipmentModel>(e => e.RowGuid, RowGuid) as IFilter,
            LoadPolicyNavigations: true
        } as IPolicyEquipmentModelFetchingInfo;

        this.onDataFetching?.call(this, fetchingInfo, true);

        let fetchOpt: ICallOptions = {
            url: this.getUrl,
            data: { fetchingInfo },
            onSuccess: (result) => {
                let res: any = result;
                this.createDamage(res.Data[0]);
            },
            onError: () => {

            }
        };
        await this.callApi(fetchOpt);
    }
    createDamage = (policyEquipmentModel?: IPolicyEquipmentModel) => {
        this.addLookupForm("DamageCaseCreate",
            <DamageCaseCreate
                key="DamageCaseCreate"
                invokePath={this.metadata.title}
                isChildComponent={true}
                defaultPolicyEquipmentModel={policyEquipmentModel}
                onClose={this.onLookupClosed}
            />);
    }
    inquiryPolicies = async () => {
        let fetchOpt: ICallOptions = {
            url: this.baseUrl + "/inquirypolicies",
            data: {},
            onSuccess: result => {
                if (result.ValidationState.Successful)
                    Core.successNotification("استعلام بیمه نامه ها با موفقیت انجام شد");
                this.fetchData();
            }
        };
        await this.callApi(fetchOpt);
    }
}